export const getStatsInitialData = 'Merchant/GetStatsInitialData';
export const getStatsData = 'Merchant/GetStatsData';
export const getBuyerStatsInitialData = 'Merchant/GetBuyerStatsInitialData';
export const getBuyerStatsData = 'Merchant/GetBuyerStatsData';
